<script setup lang="ts">
import ButtonLoader from './button-loader/ButtonLoader.vue';

const props = defineProps({
  mode: {
    type: String,
    default: 'button',
    validator: (value: string) => ['button', 'div'].includes(value),
  },
  type: {
    type: String,
    default: 'primary',
    validator: (value: string) =>
      ['primary', 'secondary', 'tertiary', 'outline', 'white'].includes(value),
  },
  size: {
    type: String,
    default: 'medium',
    validator: (value: string) => ['large', 'medium'].includes(value),
  },
  sizeIco: {
    type: String,
    validator: (value: string) => ['16', '20', '24', '28'].includes(value),
  },
  icon: {
    type: String,
    default: '',
  },
  counter: {
    type: Number,
    default: 0,
  },
  minWidth: {
    type: Number,
    default: 0,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  resize: {
    type: Boolean,
    default: false,
  },
  loading: {
    type: Boolean,
    default: false,
  },
  responsiveIco: {
    type: Boolean,
    default: false,
  },
  responsiveSizes: {
    type: Array as () => number[],
    default: () => [16, 16, 16, 20, 20, 20],
  },
  loadingType: {
    type: String,
    default: 'grey',
  },
  path: {
    type: [String, Object],
  },
  fill: {
    type: String,
    default: '',
  },
  stroke: {
    type: String,
    default: '',
  },
  hoverFill: {
    type: String,
    default: '',
  },
  hoverStroke: {
    type: String,
    default: '',
  },
});
const viewComponent = computed(() => props.mode);
const emit = defineEmits(['click']);
const clickButtons = (e: Event): void => {
  if (!props.disabled) {
    emit('click', e);
  }
};
</script>

<template>
  <component
    :is="viewComponent"
    :class="[
      'button-wrapper-ico',
      type,
      `button-wrapper-ico__${size}`,
      { button__disabled: disabled },
      `${type}__border`,
    ]"
    :style="[
      Number(minWidth) > 0 ? `minWidth: ${minWidth}px` : '',
      resize ? `width: 100% ` : '',
    ]"
    :disabled="disabled || loading"
    @click.prevent="clickButtons"
  >
    <div v-if="!!icon && !loading" class="button__ico-before">
      <UiIcon
        :name="icon"
        :fill="fill"
        :stroke="stroke"
        :hover-fill="hoverFill"
        :hover-stroke="hoverStroke"
        :size="sizeIco"
        :response-size="responsiveIco ? responsiveSizes : []"
      />
    </div>
    <ButtonLoader v-if="loading" :type="loadingType" />
  </component>
</template>

<style scoped lang="scss" src="./ui-button-ico-css.scss" />
